import { useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Icon,
  InputCheckbox,
  InputDate,
  InputDropdown,
  InputField,
  InputPhoneDropdown,
  InputRadio,
  InputTextarea,
  Notifications,
  Text,
} from "@jds/core";
import AvatarUpload from "./avatarUpload/AvatarUpload";
import {
  validateEmail,
  validateNameInput,
  validateNameWithOnlyLetters,
  validatePhoneNumber,
  validateTextInput,
} from "../../../util/validation";
import useInput from "../../../hooks/use-input";
import useApiHttp from "../../../hooks/use-http";
import { useParams } from "react-router-dom";
import PageLoader from "../Loader/PageLoader";
import ExcelFile from "../../../assets/excel/sample_guests.xlsx";
import {
  countryPhoneCodes,
  downloadFile,
  excelValidationCheck,
  obfuscateEmail,
  validateFileSignature,
} from "../../../util/helper";
import { Box } from "@mui/material";
import decryptUrl from "../../../util/img-decryption";
import JdsModal from "../JdsModal";
export default function EditGuestForm(props) {
  const data = props?.data;
  const role = props?.data?.role || "GUEST";
  const { sendRequest: editGuest, isLoading: guestEditing } = useApiHttp();
  const { sendRequest: deleteGuest, isLoading: guestDeleteing } = useApiHttp();
  const { sendRequest: getFaceCount, isLoading: isGetFaceCounting } =
    useApiHttp();
  const { sendRequest: getContactInfoApi, isLoading: contactInfoIsLoading } =
    useApiHttp();
  const [selectedCountry, setSelectedCountry] = useState(0);
  const [imgChange, setImgChange] = useState(false);
  const { id: eventId } = useParams();
  const [isDeleteModalClose, setDeleteModalClose] = useState(true);
  const [customFields, setCustomFields] = useState({});
  const [formValueForCustom, setFormValueForCustom] = useState(
    props?.data?.customFields || {},
  );
  // {

  // "48f5b416-17f9-4015-9267-4d6fc3bd677d": ["four", "two"],
  // "d45f0c34-4380-4e41-9ce8-bfec81f4775c": "sample chagne text",
  // "866a62e4-982c-4261-a9ff-e80ffdaecaad": "2024/08/02",
  // "ba2a9c4d-fa92-4ff0-8e33-f4917a95e318": "one",
  // "71b3e981-76a3-43c8-9ca6-ae815b4e4b62": "teste",
  // "b368463f-9e86-4af2-8a20-b5f95a2ac386": "three",
  // "4ca27278-b135-4444-8c92-e36ca10bb387": true,
  // }
  const {
    value: profileImage,
    isValid: isValidProfileImage,
    hasError: profileImageError,
    valueChangeHandler: profileImageChangeHandler,
    inputBlurHandler: profileImageBlurHandler,
    reset: resetProfileImage,
  } = useInput(
    (data) => {
      return typeof data === "object" ? true : false;
    },
    {
      type: "text",
      value: data?.profilePic,
    },
  );

  const {
    value: firstName,
    isValid: isValidFirstName,
    hasError: firstNameError,
    valueChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstName,
  } = useInput(
    (data) => {
      if (typeof data !== "string") return false;
      if (data.length > 20) return false;
      const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
      return pattern.test(data.trim());
    },
    {
      type: "text",
      value: data?.firstName,
    },
  );
  const {
    value: lastName,
    isValid: isValidlastName,
    hasError: lastNameError,
    valueChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetLastName,
  } = useInput(
    (data) => {
      if (typeof data !== "string") return false;
      if (data.length > 20) return false;
      const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
      return pattern.test(data.trim());
    },
    {
      type: "text",
      value: data?.lastName,
    },
  );
  const {
    value: phoneNumber,
    isValid: isValidPhoneNumber,
    hasError: phoneNumberError,
    valueChangeHandler: phoneNumberChangeHandler,
    inputBlurHandler: phoneNumberBlurHandler,
    reset: resetPhoneNumber,
  } = useInput(validatePhoneNumber, {
    type: "text",
    value: data?.phoneNumber,
  });

  const finalEmailvalidation = (email) => {
    const emailPattern = /^[a-z0-9.]+@[^\s@]+\.[^\s@]+$/i; // Added case-insensitive flag for robustness

    return emailPattern.test(email);
  };

  const {
    value: emailAddress,
    isValid: isValidEmailAddress,
    hasError: emailAddressError,
    valueChangeHandler: emailAddressChangeHandler,
    inputBlurHandler: emailAddressBlurHandler,
    isTouched: emailIsTouched,
    reset: resetEmailAddress,
  } = useInput(finalEmailvalidation, {
    type: "email",
    value: data?.email || "",
  });
  // const customFieldsValidtion = Object.entries(customFields)?.every(
  //   ([key, item]) => {
  //     if (item.required) {
  //       return (
  //         formValueForCustom[item.id] !== undefined &&
  //         formValueForCustom[item.id] !== "" &&
  //         formValueForCustom[item.id] !== false
  //       );
  //     }
  //     return true;
  //   }
  // );
  const isValidForm =
    isValidFirstName && isValidlastName && isValidEmailAddress;

  const handleSubmit = () => {
    const countryCode = countryCodeItems.filter((items, index) => {
      if (index == selectedCountry) {
        return items;
      }
    })[0]?.value;
    const guestData = {
      id: data?.userId,
      profilePicture: imgChange ? profileImage : data?.profileFile,
      firstName,
      lastName,
      email: emailAddress ? obfuscateEmail(emailAddress) : data?.email,
    };
    const formData = new FormData();
    formData.append("id", data?.userId);
    formData.append("eventId", eventId);
    // formData.append("profilePicture", profileImage || data?.profilePic);
    imgChange &&
      formData.append("profilePicture", imgChange ? profileImage : null);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("email", emailAddress || "");
    formData.append("customField", JSON.stringify(formValueForCustom));
    formData.append("role", role);
    if (imgChange) {
      const faceCheck = new FormData();
      faceCheck.append("uploadFile", profileImage);
      getFaceCount(
        {
          base: "MEDIA",
          url: `face/get-face-count`,
          method: "POST",
          body: faceCheck,
          formData: true,
        },
        null,
        (data) => {
          editGuest(
            {
              // base: "AUTH",
              url: `event-attendee/guest/profile-image`,
              method: "POST",
              body: formData,
              formData: true,
            },
            null,
            (data) => {
              Notifications.toast.success({
                id: "edit-user",
                title: data?.message,
              });
              props.closeModal();
              props?.onSuccess(guestData, true);
            },
            (err, data) => {
              Notifications.toast.error({
                id: "edit-user",
                title: data?.message,
              });
            },
          );
        },
        (err, data) => {
          Notifications.toast.error({
            id: "get-face-count-error",
            title: data?.message,
          });
        },
      );
    } else {
      editGuest(
        {
          // base: "AUTH",
          url: `event-attendee/guest/profile-image`,
          method: "POST",
          body: formData,
          formData: true,
        },
        null,
        (data) => {
          Notifications.toast.success({
            id: "edit-user",
            title: data?.message,
          });
          props.closeModal();
          props?.onSuccess(guestData, true);
        },
        (err, data) => {
          Notifications.toast.error({
            id: "edit-user",
            title: data?.message,
          });
        },
      );
    }
  };

  const handleDelete = () => {
    deleteGuest(
      {
        url: `event-attendee/delete`,
        method: "DELETE",
        body: {
          eventId: eventId,
          userId: data?.userId,
        },
      },
      null,
      (res) => {
        Notifications.toast.success({
          id: "delete-guest",
          title: res?.message,
        });
        props.closeModal();
        props?.onSuccess({ id: data?.userId }, false);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "delete-guest",
          title: data?.message,
        });
      },
    );
  };
  //   const countryCodeItems = [
  //     {
  //       label: "+91",
  //       prefix: <Icon ic={"IcAdd"} />,
  //       value: "+91",
  //     },
  //     {
  //       label: "+88",
  //       prefix: <Icon ic={"IcAdd"} />,
  //       value: "+88",
  //     },
  //     {
  //       label: "+78",
  //       prefix: <Icon ic={"IcAdd"} />,
  //       value: "+78",
  //     },
  //   ];

  const countryCodeItems = countryPhoneCodes.map((obj) => ({
    label: obj?.dial_code,
    value: obj?.dial_code,
  }));

  const inputFieldsRender = (key, item) => {
    switch (item.type) {
      case "text":
        return (
          <InputField
            label={`${item.questionName} ${item.required ? "*" : ""}`}
            onChange={(e) => {
              setFormValueForCustom((pre) => {
                return { ...pre, [key]: e.target.value };
              });
            }}
            value={formValueForCustom[key]}
          />
        );
      case "dropdown":
        return (
          <InputDropdown
            label={`${item.questionName} ${item.required ? "*" : ""}`}
            items={item.options?.map((val) => {
              return {
                label: val,
                value: val,
              };
            })}
            onSelect={(i, value) => {
              setFormValueForCustom((pre) => {
                return { ...pre, [key]: value };
              });
            }}
            value={formValueForCustom[key]}
          />
        );

      case "date":
        return (
          <InputDate
            label={`${item.questionName} ${item.required ? "*" : ""}`}
            onChange={(value) => {
              setFormValueForCustom((pre) => {
                return { ...pre, [key]: value };
              });
            }}
            value={formValueForCustom[key]}
          />
        );
      case "consent":
        return (
          <InputCheckbox
            label={
              <Text
                text={`${item.questionName} ${item.required ? "*" : ""}`}
                appearance="body-xs"
                color="primary_grey_80"
              />
            }
            size="small"
            onChange={(e) => {
              setFormValueForCustom((pre) => {
                return { ...pre, [key]: e.target.checked };
              });
            }}
            checked={formValueForCustom[key]}
          />
        );

      case "checkbox":
        return (
          <div style={{ width: "100%" }}>
            <Container direction="column" fullWidth>
              <Text
                text={`${item.questionName} ${item.required ? "*" : ""}`}
                appearance="body-xs"
                color="primary_grey_80"
              />
              <Container
                gap={40}
                fullWidth
                style={{
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                <Container fullWidth direction="column" gap={8}>
                  {item.options?.map((val) => (
                    <InputCheckbox
                      label={
                        <Text
                          text={`${val}`}
                          appearance="body-xs"
                          color="primary_grey_80"
                        />
                      }
                      size="small"
                      value={val}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFormValueForCustom((pre) => {
                            const formValue = { ...pre };
                            const checkBoxValue = pre[key] || [];
                            formValue[key] = [...checkBoxValue, e.target.value];
                            return formValue;
                          });
                        } else {
                          setFormValueForCustom((pre) => {
                            const formValue = { ...pre };
                            const checkBoxValue = pre[key] || [];
                            const filterData = checkBoxValue.filter((item) => {
                              if (item !== e.target.value) {
                                return item;
                              }
                            });
                            formValue[key] = filterData;
                            return formValue;
                          });
                        }
                      }}
                      checked={
                        formValueForCustom[key]?.filter((item) => item == val)
                          .length
                          ? true
                          : false
                      }
                    />
                  ))}
                </Container>
              </Container>
            </Container>
          </div>
        );

      case "paragraph":
        return (
          <>
            <InputTextarea
              label={`${item.questionName} ${item.required ? "*" : ""}`}
              rows={2}
              onChange={(e) => {
                setFormValueForCustom((pre) => {
                  return { ...pre, [key]: e.target.value };
                });
              }}
              value={formValueForCustom[key]}
            />
          </>
        );
      case "radio":
        return (
          <>
            <Container direction="column" gap={8} fullWidth>
              <Text
                text={`${item.questionName} ${item.required ? "*" : ""}`}
                appearance="body-xs"
                color="primary_grey_80"
              />
              <Container gap={8} fullWidth>
                {item.options?.map((val) => (
                  <InputRadio
                    label={val}
                    suffix="ic_profile"
                    prefix="ic_profile"
                    size="small"
                    checked={formValueForCustom[key] === val ? true : false}
                    onClick={(e) => {
                      setFormValueForCustom((pre) => {
                        return { ...pre, [key]: e.target.value };
                      });
                    }}
                    value={val}
                  />
                ))}{" "}
              </Container>
            </Container>
          </>
        );

      default:
        return <></>;
    }
  };

  useEffect(() => {
    setCustomFields({ ...props?.customFields });
  }, []);
  useEffect(() => {
    if (data?.id) {
      getContactInfoApi(
        {
          url: `event-attendee/${eventId}/view-contact/${data?.id}`,
        },
        () => {},
        (data) => {
          emailAddressChangeHandler({
            target: {
              value: decryptUrl(data?.data?.email)?.replace(
                /[\x00-\x1F\x7F]/g,
                "",
              ),
            },
          });
        },
      );
    }
  }, [data?.id]);
  return (
    <>
      <div className="column-form full-width">
        <AvatarUpload
          accept=".png ,.jpg ,.jpeg"
          fileValue={(value) => {
            profileImageChangeHandler({ target: { value } });
            setImgChange(true);
          }}
          error={profileImageError}
          errorText={"Invalid Image"}
          id={"add-guest"}
          image={
            data?.profileFile
              ? URL.createObjectURL(data?.profileFile)
              : data?.profilePic
                ? // ? decryptUrl(data.profilePic)
                  data.profilePic
                : ""
          }
        />
        <InputField
          label="First Name *"
          value={firstName}
          name="firstName"
          onChange={(e) => {
            firstNameChangeHandler(e, e.target.value);
          }}
          onBlur={firstNameBlurHandler}
          state={firstNameError ? "error" : ""}
          stateText={
            firstName?.length > 20
              ? "The First name length can't exceed 20 characters"
              : firstName?.length == 0
                ? "The First name can't be blank"
                : "The First name can't contain spaces, special characters and numbers"
          }
        />
        <InputField
          label="Last Name *"
          value={lastName}
          name="lastName"
          state={lastNameError ? "error" : ""}
          onChange={(e) => {
            lastNameChangeHandler(e, e.target.value);
          }}
          onBlur={lastNameBlurHandler}
          stateText={
            lastName?.length > 20
              ? "The Last name length can't exceed 20 characters"
              : lastName?.length == 0
                ? "The Last name can't be blank"
                : "The Last name can't contain spaces, special characters and numbers"
          }
        />

        <InputField
          label="Phone Number *"
          value={phoneNumber}
          name="phoneNumber"
          disabled
        />
        <Box>
          <InputField
            label="Email"
            value={emailAddress}
            name="emailAddress"
            type={"email"}
            onChange={emailAddressChangeHandler}
            onBlur={emailAddressBlurHandler}
            state={emailAddressError ? "error" : ""}
            stateText="Please enter valid email id!"
            required
          />
        </Box>

        {/* {role == "GUEST" &&
          Object.entries(customFields).map(([key, value]) =>
            inputFieldsRender(key, value)
          )} */}

        <Container
          fullWidth
          direction="row"
          gap={24}
          style={{ margin: "32px 0" }}
        >
          <Button
            fullWidth
            disabled={!isValidForm}
            type="submit"
            label="Update"
            size="large"
            onClick={handleSubmit}
          />
          <Button
            fullWidth
            type="submit"
            kind="secondary"
            label="Block"
            size="large"
            state="destructive"
            onClick={() => {
              setDeleteModalClose(false);
            }}
          />
        </Container>
      </div>

      <JdsModal
        size="m"
        header={`Are you sure you want to block the ${
          role == "GUEST" ? "guest" : "photographer"
        }?`}
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isDeleteModalClose}
        onClose={() => {
          setDeleteModalClose(true);
        }}
        onPrimaryClick={() => {
          handleDelete();
        }}
        onSecondaryClick={() => setDeleteModalClose(true)}
        primaryCtaDisabled={guestDeleteing}
      />

      {(guestEditing || isGetFaceCounting || contactInfoIsLoading) && (
        <PageLoader
          open={guestEditing || isGetFaceCounting || contactInfoIsLoading}
        />
      )}
    </>
  );
}
